module.exports = __webpack_public_path__ + "img/imgs7.f9bd0732.png";